import { Step, Stepper } from '@/components/ui/stepper'

interface Props {
  steps: string[]
  currentStep: number
}

export function StepsComponent({ steps, currentStep }: Props) {
  return (
    <Stepper activeStep={currentStep}>
      {steps.map((step, i) => (
        <Step key={i}>{step}</Step>
      ))}
    </Stepper>
  )
}
